<div class="custom-snackbar d-flex justify-content-between" [ngClass]="data.icon">
    <div class="row m-0 p-0" style="border-radius: 4px; background-color: white;">
        <div class="col-1 d-flex justify-content-center align-items-center" [ngClass]="'icon-div-l-' + data.icon">
            @if (data.icon === "error") {
            <svg viewBox="0 0 24 24" height="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <path d="M12 8V12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    </path>
                    <path d="M12 16.0195V16" stroke="#000000" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                    <circle cx="12" cy="12" r="10" stroke="#000000" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></circle>
                </g>
            </svg>
            } @else if (data.icon === "success") {
            <svg viewBox="0 0 24 24" height="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <path d="M4.89163 13.2687L9.16582 17.5427L18.7085 8" stroke="#000000" stroke-width="2.5"
                        stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
            </svg>
            } @else if (data.icon === "info") {
            <svg viewBox="0 0 24 24" height="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <path
                        d="M12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V11C12.75 10.5858 12.4142 10.25 12 10.25C11.5858 10.25 11.25 10.5858 11.25 11V17C11.25 17.4142 11.5858 17.75 12 17.75Z"
                        fill="#1C274C"></path>
                    <path
                        d="M12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
                        fill="#1C274C"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C6.06294 22.75 1.25 17.9371 1.25 12ZM12 2.75C6.89137 2.75 2.75 6.89137 2.75 12C2.75 17.1086 6.89137 21.25 12 21.25C17.1086 21.25 21.25 17.1086 21.25 12C21.25 6.89137 17.1086 2.75 12 2.75Z"
                        fill="#1C274C"></path>
                </g>
            </svg>
            } @else if (data.icon === "warning") {
            <svg viewBox="0 0 24 24" height="50px" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <circle cx="12" cy="17" r="1" fill="#000000"></circle>
                    <path d="M12 10L12 14" stroke="#000000" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round"></path>
                    <path
                        d="M3.44722 18.1056L10.2111 4.57771C10.9482 3.10361 13.0518 3.10362 13.7889 4.57771L20.5528 18.1056C21.2177 19.4354 20.2507 21 18.7639 21H5.23607C3.7493 21 2.78231 19.4354 3.44722 18.1056Z"
                        stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                </g>
            </svg>
            }
        </div>

        <div class="col-10 align-content-center">
            @if (data.icon === "error") {
            <h5 class="mb-0"><b>{{ 'common.error' | translate }}</b></h5>
            } @else if (data.icon === "success") {
            <h5 class="mb-0"><b>{{ 'common.success' | translate }}</b></h5>
            } @else if (data.icon === "info") {
            <h5 class="mb-0"><b>{{ 'common.info' | translate }}</b></h5>
            } @else if (data.icon === "warning") {
            <h5 class="mb-0"><b>{{ 'common.warning' | translate }}</b></h5> }
            @if (chatSupportMessage; as message) {
            <p class="mb-0">{{ message.before }}<a [href]="message.url" target="_blank" rel="noopener noreferrer">{{ message.linkText }}</a>{{ message.after }}</p>
            } @else {
            <p class="mb-0">{{ (data.message | translate) || 'Request Failed.' }}</p>
            }
            <!-- <p class="mb-0">{{ (data.message | translate) || 'Request Failed.' }}</p> -->
        </div>
    </div>
    <div class="col-1 align-content-center text-center">
        <mat-icon>
            <svg (click)="closeSnackBar()" (keydown.enter)="closeSnackBar()" style="cursor: pointer;" width="15px"
                height="15px" viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" tabindex="0" role="button" aria-label="Close dialog">
                <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <g id="ic_fluent_dismiss_28_regular" fill="#212121" fill-rule="nonzero">
                        <path
                            d="M3.52499419,3.71761187 L3.61611652,3.61611652 C4.0717282,3.16050485 4.79154862,3.13013074 5.28238813,3.52499419 L5.38388348,3.61611652 L14,12.233 L22.6161165,3.61611652 C23.1042719,3.12796116 23.8957281,3.12796116 24.3838835,3.61611652 C24.8720388,4.10427189 24.8720388,4.89572811 24.3838835,5.38388348 L15.767,14 L24.3838835,22.6161165 C24.8394952,23.0717282 24.8698693,23.7915486 24.4750058,24.2823881 L24.3838835,24.3838835 C23.9282718,24.8394952 23.2084514,24.8698693 22.7176119,24.4750058 L22.6161165,24.3838835 L14,15.767 L5.38388348,24.3838835 C4.89572811,24.8720388 4.10427189,24.8720388 3.61611652,24.3838835 C3.12796116,23.8957281 3.12796116,23.1042719 3.61611652,22.6161165 L12.233,14 L3.61611652,5.38388348 C3.16050485,4.9282718 3.13013074,4.20845138 3.52499419,3.71761187 L3.61611652,3.61611652 L3.52499419,3.71761187 Z"
                            id="🎨-Color">

                        </path>
                    </g>
                </g>
            </svg>
        </mat-icon>
    </div>
</div>